import React, { useEffect, useState } from 'react';
import DocumentLink from '../../components/documents/DocumentLink';
import PageTab from '../../components/dashboard/PageTab';
import PageTabTitle from '../../components/dashboard/PageTabTitle';
import PageTabBody from '../../components/dashboard/PageTabBody';

const OtherLegalDocuments = () => {
  const [documents, setDocuments] = useState([]);

  useEffect(() => {
    try {
      const context = require.context('/public/legalDocuments/other', false, /\.pdf$/);
      const docs = context.keys();

      setDocuments(docs);
    } catch (error) {
      console.error("Directory '/public/legalDocuments/other' does not exist.");
    }
  }, []);

  return (
    <PageTab>
      <PageTabTitle>Kiti dokumentai</PageTabTitle>
      <PageTabBody>
        {documents.map((filename, index) => (
          <DocumentLink key={index} directory={'/legalDocuments/other'} filename={filename} />
        ))}
      </PageTabBody>
    </PageTab>
  );
};

export default OtherLegalDocuments;
